import PropTypes from "prop-types";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import moment from "moment";

function Transaction({ transaction, selectedAccount, openEditModal }) {
    return (
        <MDBox py={1} pr={2} mb={1}>
            <MDBox display="flex" justifyContent="space-between" alignItems="center">
                <MDBox display="flex" alignItems="center">
                <MDBox mr={2}>
                    <MDButton variant="outlined" color={transaction.amount > 0 ? "success" : "error"} iconOnly circular>
                        <Icon onClick={() => openEditModal(transaction)} sx={{ fontWeight: "bold" }}>{transaction.amount > 0 ? "expand_more" : "expand_less"}</Icon>
                    </MDButton>
                </MDBox>
                <MDBox display="flex" flexDirection="column">
                    <MDTypography variant="button" fontWeight="medium" gutterBottom>
                        {transaction.category}
                    </MDTypography>
                    <MDTypography variant="caption" color="text" fontWeight="regular">
                        <b>{moment(transaction.date).format("HH:mm")}</b> {transaction.note}
                    </MDTypography>
                </MDBox>
                </MDBox>
                <MDTypography variant="button" color={transaction.amount > 0 ? "success" : "error"} fontWeight="medium" textGradient>
                    {new Intl.NumberFormat("en-US", {style: "currency", currency: (selectedAccount?.currency ?? "USD"), minimumFractionDigits: 2, maximumFractionDigits: 2}).format(transaction.amount / 100)}
                </MDTypography>
            </MDBox>
        </MDBox>
    );
}

Transaction.propTypes = {
    transaction: PropTypes.object.isRequired,
    openEditModal: PropTypes.func.isRequired,
};

export default Transaction;
